import { getAppI18nConfig, initI18n } from 'cfgi18n';
import type { GetServerSideProps } from 'next';

import {
	getPlayerProfie,
	GetPlayerProfileResponse,
	getPlayers,
	GetPlayersResponse,
} from 'services/players';

import { Seo } from 'core/mancity/components/general/seo';

import { LandingLayout } from '@players/layouts/landing';
import { ProfileLayout } from '@players/layouts/profile';

const landingQuery = ['mens', 'womens', 'eds', 'academy', 'esports'];

type PageProps = {
	playersListData: GetPlayersResponse | null;
	playerProfileData: GetPlayerProfileResponse | null;
	team: string;
};

export default function Page({
	playersListData,
	playerProfileData,
	team,
}: PageProps) {
	const head = playersListData?.head ?? playerProfileData?.head;

	return (
		<>
			{head && <Seo head={head} />}
			{playersListData && (
				<LandingLayout team={team} data={playersListData} />
			)}
			{playerProfileData && <ProfileLayout data={playerProfileData} />}
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const { query } = context.params as { query: Array<string> };
	const isLanding = Array.isArray(query) && landingQuery.includes(query[0]);
	const locale = context.locale as string;

	try {
		let playersListData = null;
		let playerProfileData = null;

		const { supportedLocales } = await getAppI18nConfig('players');
		await initI18n(locale, supportedLocales);

		if (isLanding) {
			const response = await getPlayers(query[0], locale);
			playersListData = response.data;
		} else {
			const response = await getPlayerProfie(query[0], locale);
			playerProfileData = response.data;
		}

		if (!playersListData && !playerProfileData) {
			return { notFound: true };
		}

		return {
			props: {
				playersListData,
				playerProfileData,
				team: query[0],
				locale,
			},
		};
	} catch (error) {
		console.error('Server-side error:', error);
		return {
			redirect: {
				destination: '/500',
				permanent: false,
			},
		};
	}
};
